import type { CourseDetailDto } from '../services/contentService';

type Translate = (key: string, options?: Record<string, unknown>) => string;

/** "Lesson 3" / "درس ۳", falling back to the plain lesson label when the number is unknown. */
export function lessonHeroEyebrow(
  t: Translate,
  lessonNumber: number | null | undefined,
  locale: string
): string {
  const label = t('lesson.heroEyebrow');
  if (lessonNumber == null || lessonNumber < 1) return label;
  const n = lessonNumber.toLocaleString(locale === 'fa' ? 'fa-IR' : 'en-US');
  return t('lesson.heroEyebrowNumber', { n, defaultValue: `${label} ${n}` });
}

/**
 * Structured-path lesson number carried on the course payload.
 * Falls back to the visible-list index only when that number is absent.
 */
export function lessonNumberFromCourse(
  course: CourseDetailDto | null | undefined,
  lessonId: number,
  levelId: number
): number | null {
  const level = course?.levels?.find((item) => item.id === levelId);
  if (!level?.lessons?.length) return null;
  const match = level.lessons.find((item) => item.id === lessonId);
  if (typeof match?.lessonNumber === 'number' && match.lessonNumber > 0) return match.lessonNumber;
  const lessons = [...level.lessons].sort(
    (a, b) => a.displayOrder - b.displayOrder || a.id - b.id
  );
  const index = lessons.findIndex((item) => item.id === lessonId);
  return index >= 0 ? index + 1 : null;
}

export function resolveLessonHeroNumber(
  lesson: { id: number; levelId: number; lessonNumber?: number },
  course?: CourseDetailDto | null
): number | null {
  if (typeof lesson.lessonNumber === 'number') {
    return lesson.lessonNumber > 0 ? lesson.lessonNumber : null;
  }
  return lessonNumberFromCourse(course, lesson.id, lesson.levelId);
}
